import React from 'react'

/**
 * RadioCircle
 *
 * @param {boolean} active   - whether the radio is selected
 * @param {'check'|'dot'} variant - active state style. 'check' = filled blue with checkmark, 'dot' = bordered with inner dot
 */
export function RadioCircle({active = false, variant = 'check', ...props}) {
  const inactive = (
    <svg
      width="18"
      height="18"
      viewBox="-1 -1 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{flexShrink: 0, display: 'block'}}
      {...props}
    >
      <rect x="0.5" y="0.5" width="15" height="15" rx="7.5" fill="white" />
      <rect x="0.5" y="0.5" width="15" height="15" rx="7.5" stroke="#A5B7F6" />
    </svg>
  )

  if (!active) return inactive

  if (variant === 'dot') {
    return (
      <svg
        width="18"
        height="18"
        viewBox="-1 -1 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{flexShrink: 0, display: 'block'}}
        {...props}
      >
        <rect x="0.5" y="0.5" width="15" height="15" rx="7.5" fill="#F4F6FB" />
        <rect
          x="0.5"
          y="0.5"
          width="15"
          height="15"
          rx="7.5"
          stroke="#A5B7F6"
        />
        <circle cx="8" cy="8" r="4.5" fill="#0049D4" />
      </svg>
    )
  }

  return (
    <svg
      width="18"
      height="18"
      viewBox="-1 -1 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{flexShrink: 0, display: 'block'}}
      {...props}
    >
      <rect width="16" height="16" rx="8" fill="#0049D4" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.05112 10.7952L11.7217 5.1247C11.8887 4.95758 12.163 4.95929 12.3284 5.1247L12.8759 5.67218C13.0413 5.83759 13.0413 6.11361 12.8759 6.27895L7.20544 11.9495C7.04003 12.1149 6.76572 12.1166 6.5986 11.9495L6.05112 11.402C5.884 11.2349 5.884 10.9623 6.05112 10.7952Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.27887 7.33916L7.73308 10.7934C7.90014 10.9605 7.89817 11.2351 7.73308 11.4002L7.1856 11.9477C7.02051 12.1127 6.74386 12.1127 6.57877 11.9477L3.12456 8.49348C2.95946 8.32838 2.9575 8.05376 3.12456 7.88664L3.67204 7.33916C3.83916 7.1721 4.11175 7.1721 4.27887 7.33916Z"
        fill="white"
      />
    </svg>
  )
}
